/* eslint-disable import/no-named-as-default-member */
/**
 * Created by tombray on 11/23/14.
 */
import DriverWebAPIUtils from '../utils/DriverWebAPIUtils';
import CarrierDriverWebAPIUtils from '../utils/CarrierDriverWebAPIUtils';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;

export default {
  getDriverWaypoints: function (id, start, end) {
    DriverWebAPIUtils.getDriverWaypoints(id, start, end);
  },

  getAvailableDrivers: function () {
    DriverWebAPIUtils.getAvailableDrivers();
  },

  getNearbyDrivers: function (
    filters,
    shipper_id = null,
    shipment_type = null,
  ) {
    if (shipper_id) {
      filters.shipper_id = shipper_id;
    }
    if (shipment_type) {
      filters.shipment_type = shipment_type;
    }
    DriverWebAPIUtils.getNearbyDrivers(filters);
  },

  getNearbyDriversForCarrier: function (id, filters) {
    CarrierDriverWebAPIUtils.getNearbyDrivers(id, filters);
  },
  getAuthorizedDrivers: function () {
    DriverWebAPIUtils.getAuthorizedDrivers();
  },

  getAuthorizedDriversForCarrier: function (id) {
    CarrierDriverWebAPIUtils.getAuthorizedDrivers(id);
  },

  getAllDriversForCarrier: function (id) {
    CarrierDriverWebAPIUtils.getAllDrivers(id);
  },
  toggleDriverAuthorization: function (id, status) {
    CarrierDriverWebAPIUtils.toggleAuthorization({ driver_id: id, status });
  },
  toggleReceiveOffers: function (id, status) {
    CarrierDriverWebAPIUtils.toggleReceiveOffers({ driver_id: id, status });
  },
  toggleMultiplePickup: function (id, status) {
    CarrierDriverWebAPIUtils.toggleMultiplePickup({ driver_id: id, status });
  },
  acceptOffer: function ({ driverId, offerId, offerName }) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.ACCEPT_OFFER_REQUEST,
      driverId,
      offerId,
      offerName,
    });
  },
  resetAssignDriver: function () {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.ASSIGN_DRIVER_RESET,
    });
  },
  getAvailableDriversByMarket: function (params, options = {}) {
    DriverWebAPIUtils.getAvailableDriversByMarket(params, options);
  },
};
